import { render, staticRenderFns } from "./NoDataLoaded.vue?vue&type=template&id=1a67c836&"
import script from "./NoDataLoaded.vue?vue&type=script&lang=js&"
export * from "./NoDataLoaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports